import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GeschwisterkindDto} from '../../../models/geschwister/GeschwisterkindDto';
import {GeschwisterkinderSetDto} from '../../../models/geschwister/GeschwisterkinderSetDto';
import {HttpHeaderService} from '../../utils/http/http-header.service';

@Injectable({
  providedIn: 'root'
})
export class GeschwisterService {

  private readonly baseUrl = 'api/student-ticket/geschwister';

  constructor(
    private readonly http: HttpClient,
    private readonly headerService: HttpHeaderService
  ) {}

  getGeschwisterkinder(ticketId: string): Observable<GeschwisterkindDto[]> {
    return this.http.get<GeschwisterkindDto[]>(
      `${this.baseUrl}/${ticketId}`,
      {headers: this.headerService.getAuthHeaderApplicationJson()}
    );
  }

  setGeschwisterkinder(ticketId: string, geschwisterkindIds: number[]): Observable<GeschwisterkinderSetDto> {
    return this.http.post<GeschwisterkinderSetDto>(
      `${this.baseUrl}/${ticketId}`,
      {geschwisterkindIds},
      {headers: this.headerService.getAuthHeaderApplicationJson()}
    );
  }

  isTwinCase(ticketId: string): Observable<{isTwinCase: boolean}> {
    return this.http.get<{isTwinCase: boolean}>(
      `${this.baseUrl}/${ticketId}/twin-case`,
      {headers: this.headerService.getAuthHeaderApplicationJson()}
    );
  }
}

